module.exports = __webpack_public_path__ + "static/media/takeaway-white.ff249ead.svg";